import React, { useContext } from 'react';
import { DataContext } from '../context/contextApi';

const ToastContainer = () => {
  const { toasts, removeToast } = useContext(DataContext);
  return (
    <div className="fixed top-20 right-4 z-50 flex flex-col gap-2 w-auto max-w-sm">
      {toasts && toasts.map((t) => (
        <div key={t.id} className={`px-4 py-2 rounded shadow-md bg-white dark:bg-gray-800 border ${t.type === 'error' ? 'border-red-400' : 'border-gray-200'}`}>
          <div className="flex items-center justify-between gap-4">
            <div className="text-sm text-black dark:text-white">{t.message}</div>
            <button onClick={() => removeToast(t.id)} className="text-xs text-gray-500">✕</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;